import React from 'react';

export function Privacy() {
  return (
    <div className="min-h-screen pt-32 pb-24 px-6 container mx-auto flex flex-col items-center">
      <div className="text-center space-y-6 mb-16 max-w-4xl">
        <h1 className="font-display text-4xl md:text-7xl uppercase text-white leading-none">
          Privacy <br/>
          <span className="text-[var(--color-sansi-orange)]">Policy</span>
        </h1>
      </div>

      <div className="max-w-4xl w-full text-lg text-gray-300 font-light leading-relaxed space-y-8">
        <section>
          <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
          <p>
            We collect personal information such as your name, address, phone number, and email when you place an order.
            This information is used solely for processing your order and keeping you updated.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">2. Use of Information</h2>
          <p>
            Your information helps us improve our services, process payments, and ensure timely delivery. We may also send 
            updates about new products or offers if you subscribe to our newsletter.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">3. Data Security</h2>
          <p>
            We implement strict security measures to protect your personal data. We do not sell or share your 
            information with third parties for marketing purposes.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">4. Cookies</h2>
          <p>
            Our website uses cookies to enhance your browsing experience. You can choose to disable cookies in your text
            browser settings, though this may affect some site functionalities.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">5. Third-Party Services</h2>
          <p>
            We may use trusted third-party services for payments and delivery. These providers have their own privacy 
            policies, which we encourage you to review.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">6. Updates to Policy</h2>
          <p>
            We reserve the right to update this privacy policy at any time. Any changes will be posted on this page.
          </p>
        </section>
      </div>
    </div>
  );
}
